<template>
<div class="servecarousel">
    <div class="swiper-box">
        <!-- <ul class="swiper-wrapper">
        <li class="swiper-slide" v-for="item in companylist" :key="item.id">
            <div :class="['img',`img-${item.id}`]" :style="{backgroundImage:'url(' + item.logo+ ')'}" :title="item.name">
            </div>
        </li>
       
      </ul> -->
        <Swiper ref="mySwiper" :options="swiperOptions2">
            <SwiperSlide class="swiperItem" v-for="(item, index) in companylist.even" :key="index">
                <div :class="['img', `img-${item.id}`]" :style="{ backgroundImage: 'url(' + item.logo + ')' }" :title="item.name"
				@click="openUrl(item.url)"></div>
                <div :class="[
              'img',
              `img-${companylist.odd[index] ? companylist.odd[index].id : ''}`,
            ]" :style="{
              backgroundImage: `url('${
                companylist.odd[index] ? companylist.odd[index].logo : ''
              }')`,
            }" style="margin-top: 20px" :title="`${
              companylist.odd[index] ? companylist.odd[index].name : ''
            }`"
			@click="openUrl(companylist.odd[index] ? companylist.odd[index].url : '')"></div>
            </SwiperSlide>
        </Swiper>
        <!-- <Swiper ref="mySwiper" :options="swiperOptions3">
            <SwiperSlide class="swiperItem" v-for="(item, index) in companylist2" :key="index">
                <div :class="['img',`img-${item.id}`]" :style="{backgroundImage:'url(' + item.logo+ ')'}" :title="item.name"></div>
            </SwiperSlide>
        </Swiper> -->
    </div>
</div>
</template>

<script>
import CompanyList from "../data/serveComany";
import {
    Swiper,
    SwiperSlide
} from "vue-awesome-swiper";
export default {
    data() {
        return {
            companylist: {
                odd: [],
                even: [],
            },
            swiperOptions2: {
                // 自动播放
                autoplay: {
					delay: 5000,
				},
                // 环路播放
                loop: true,
                slidesPerView: 4,
                slidesPerGroup: 4,
                observeParents: true,
                observer: true,
                preventLinksPropagation: true,
				
            },
            swiperOptions3: {
                // 自动播放
                autoplay: true,
                // 环路播放
                loop: true,
                slidesPerView: 4,
                slidesPerGroup: 4,
                observeParents: true,
                observer: true,
                preventLinksPropagation: true,
            },
        };
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    computed: {
        backgroundImg(link) {
            //console.log(link);
            return {
                color: "red",
            };
        },
    },
    beforeMount() {
        CompanyList.companyList.forEach((i, index) => {
            if (index % 2 == 0) {
                this.companylist.even.push(i);
            } else {
                this.companylist.odd.push(i);
            }
        });
        // console.log("this.companylist :>> ", this.companylist);
    },
	methods: {
		openUrl(url) {
			window.open(url)
		}
	}
};
</script>

<style lang="scss" scoped>
.servecarousel {
    width: 940px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 60px;

    .swiperItem {
        height: 170px;
    }

    .img {
        width: 200px;
        height: 60px !important;
        margin: 0 8px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 130px;
        margin: auto;
        box-shadow: 5px 5px 5px rgba($color: #ccc, $alpha: 0.5);
    }
}
</style>
